export default __webpack_public_path__ + "static/media/squares1300.77b92f71.jpg";